import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import Tmpru from '../assets/img/tmpru.png';
import Manya from '../assets/img/manya.png';
import Trucky from '../assets/img/truckway.png';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import 'swiper/css';
import { FaAward, FaHandshake } from 'react-icons/fa';
import useScrollAnimation from '../hooks/useScrollAnimation';

const Partners = () => {
    const { t } = useTranslation();
    const [partners, setPartners] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const partnersRef = useScrollAnimation(0.2);

    useEffect(() => {
        const fetchPartners = async () => {
            try {
                const response = await fetch('https://hub.mileageriot.com/api/partners');
                if (!response.ok) throw new Error('Network response was not ok');
                const json = await response.json();
                setPartners(Array.isArray(json) ? json : []);
                setLoading(false);
            } catch (err) {
                console.error('Error fetching partners:', err);
                setError('Failed to load partners');
                setLoading(false);
            }
        };
        fetchPartners();
    }, []);

    return (
        <section className="partners-modern py-5" id="partners" ref={partnersRef}>
            <div className="container">
                <div className="section-header text-center mb-5 fade-in-up">
                    <div className="section-badge">
                        <FaHandshake className="me-2" />
                        <span className="text-primary">{t('partners.title')}</span>
                    </div>
                    <h2 className="section-title text-glow text-white mb-4">{t('partners.title')}</h2>
                    <div className="section-decoration"></div>
                </div>

                <div className="row mt-5 mx-auto fade-in-up stagger-2">
                    {[
                        { to: 'https://www.youtube.com/@truckwayets2', img: Trucky, name: 'TruckWay' },
                        { to: 'https://www.youtube.com/@Manyaets2', img: Manya, name: 'Manya Мур' },
                        { to: 'https://vk.com/tmpru', img: Tmpru, name: 'TMP RU' },
                    ].map((p) => (
                        <div className="col-md-4 mx-auto mb-4" key={p.name}>
                            <Link to={p.to} target="_blank" rel="noopener noreferrer">
                                <div className="cooperation-card glass-container">
                                    <img loading="lazy" decoding="async" src={p.img} className="cooperation-logo" alt={p.name} />
                                    <div className="cooperation-overlay">
                                        <span className="cooperation-name">{p.name}</span>
                                    </div>
                                </div>
                            </Link>
                        </div>
                    ))}
                </div>
            </div>

            <div className="container mt-5">
                <div className="section-header text-center mb-5 fade-in-up stagger-3">
                    <div className="section-badge">
                        <FaAward className="me-2" />
                        <span className="text-primary">{t('partners.partners_title')}</span>
                    </div>
                    <h2 className="section-title text-glow text-white mb-4">{t('partners.partners_title')}</h2>
                    <div className="section-decoration"></div>
                </div>

                <div className="partners-carousel-container fade-in-up stagger-4">
                    {loading && (
                        <div className="text-center text-white">
                            <div className="spinner-border text-primary" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                            <p className="mt-2 text-white-50">{t('partners.loading')}</p>
                        </div>
                    )}
                    {error && <div className="text-center"><p className="text-danger">{error}</p></div>}
                    {!loading && !error && partners.length > 0 && (
                        <Swiper
                            modules={[Autoplay]}
                            spaceBetween={24}
                            loop={partners.length > 5}
                            autoplay={{ delay: 2500, disableOnInteraction: false }}
                            breakpoints={{
                                0: { slidesPerView: 1 },
                                600: { slidesPerView: 3 },
                                1000: { slidesPerView: 5 },
                            }}
                        >
                            {partners.map((partner) => (
                                <SwiperSlide key={partner.id}>
                                    <Link to={partner.url} target="_blank" rel="noopener noreferrer">
                                        <div className="partner-card glass-container">
                                            <img loading="lazy" decoding="async" src={partner.logo} className="partner-logo" alt={partner.name} />
                                            <div className="partner-overlay">
                                                <span className="partner-name">{partner.name}</span>
                                            </div>
                                        </div>
                                    </Link>
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    )}
                </div>
            </div>

            <div className="section-bg-decoration"></div>
        </section>
    );
};

export default Partners;
